export type ProductAvailability = {
  productId?: number;
  fictionalId?: number;
  availability?: number;
  alwaysVisible?: boolean;
  colorAvailabilities?: Array<ProductColorAvailability>;
};

export type ProductColorAvailability = {
  colorId: number;
  availability: number;
  alwaysVisible: boolean;
  skuAvailabilities: Array<ProductColorSkuAvailability>;
};

export type ProductColorSkuAvailability = {
  skuCode: string;
  availability: number;
  lastPieces: boolean;
  exactAvailability: null | number;
};
